import { Injectable } from '@angular/core';
import {
  ISelectedBondDetail,
} from '@carm/_core/financial-security/models/financial-security.model';
import { BehaviorSubject, of } from 'rxjs';

@Injectable()
export class FinancialSecurityBondStateService {
  private bondModel: {
    bondInfo: ISelectedBondDetail;
    type: string;
    action: string;
  };
  private loadPendingCountSubj = new BehaviorSubject<boolean>(null);
  public loadPendingCount$ = this.loadPendingCountSubj.asObservable();

  constructor() {
  }

  public clear(): void {
    this.bondModel = null;
  }

  public selectedBond(
    iBondInfo: ISelectedBondDetail,
    type: string,
    action: string
  ) {
    this.bondModel = { bondInfo: iBondInfo, type: type, action: action };
  }

  public get selectedBondForm(): { bondInfo: ISelectedBondDetail, type: string, action: string } {
    return this.bondModel;
  }

  public get selectedBondObj() {
    return of(this.bondModel);
  }

  public loadPendingCount() {
    this.loadPendingCountSubj.next(true);
  }
}
